<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El Plan de Iguala y el Ejército Trigarante</h2>
    <img @click="imageClicked(0)" src="galerias/independencia/g6/G6.jpg" class="mainphoto"/>
    <p class="photo-description">El abrazo de Acatempan. Autor Hesiquio Iriarte. Impresión litográfica, 1870. Tomada del libro: Del abrazo de Acatempan a los tratados de Córdoba: un largo camino hacia la consolidación de la independencia.</p>
    <p>Tras la muerte de Morelos en 1815, la facción insurgente se debilitó, mientras que el ejército realista comandado por el general Félix María Calleja se fortaleció, logrando la rendición de la mayor parte de los insurgentes. En el sur del territorio, Vicente Guerrero, uno de los líderes insurgentes más importantes a cargo del Regimiento de San Fernando, integrado por más de 500 hombres, continuó combatiendo a los realistas en un periodo conocido como la Resistencia.</p>
    <p>Con gran éxito Vicente Guerrero combatió a las fuerzas realistas, a cargo del militar criollo Agustín de Iturbide, esto originó que el 10 de enero de 1821 Iturbide le enviara una carta proponiéndole una alianza, lo que inicia una relación por correspondencia que culminaría con el encuentro entre ambos el 10 de febrero de 1821, lo cual es conocido como el abrazo de Acatempan, que aunque quizás nunca se realizó como tal quedó en la memoria histórica como realizado, habiendo reconocido que luchaban por una misma causa, tener un México independiente.</p>
    <p>La relación entre Iturbide y Guerrero se formalizó con la firma del  “Plan de Iguala” el 24 de febrero, este documento sentó las bases para la independencia. A través de este acuerdo ambos líderes unieron a realistas e insurgentes, conformando el Ejército Trigarante o de las tres garantías (Religión, Independencia y Unión).</p>
    <h5>VER MÁS</h5>
    <p>Para saber más, visita el siguiente enlace:<ul><li><a target="_blank" href="https://archivos.juridicas.unam.mx/www/bjv/libros/9/4074/9.pdf">archivos.juridicas.unam.mx</a></li></ul></p>
  </div>
</template>

<script>
export default {
  name: "Sala3m6",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
